// ============================================================
// System Permissions
// ============================================================
// Use these constants throughout the app for RBAC checks

export const PERMISSIONS = Object.freeze({
  // ── Super Admin ──────────────────────────────────────────
  SUPER_ADMIN_ACCESS: 'super_admin.access',
  ORGANIZATION_MANAGE: 'organization.manage',
  MODULE_MANAGE: 'module.manage',

  // ── Dashboard ────────────────────────────────────────────
  DASHBOARD_VIEW: 'dashboard.view',

  // ── Students ─────────────────────────────────────────────
  STUDENT_VIEW: 'student.view',
  STUDENT_MANAGE: 'student.manage',
  STUDENT_CREATE: 'student.create',

  // ── Fees ─────────────────────────────────────────────────
  FEE_VIEW: 'fee.view',
  FEE_MANAGE: 'fee.manage',
  FEE_COLLECT: 'fee.collect',

  // ── Schools ──────────────────────────────────────────────
  SCHOOL_SWITCH: 'school.switch',

  // ── Settings ─────────────────────────────────────────────
  SETTINGS_MANAGE: 'settings.manage',

  // ── Teacher Management (Admin/Principal) ─────────────────
  TEACHER_VIEW: 'teacher.view',
  TEACHER_MANAGE: 'teacher.manage',
  TEACHER_DELETE: 'teacher.delete',
  TEACHER_ASSIGN: 'teacher.assign',
  TEACHER_DIRECTORY_VIEW: 'teacher.directory.view',

  // ── Teacher Workspace (Teacher's own pages) ──────────────
  TEACHER_OWN_DASHBOARD: 'teacher.own.dashboard',
  TEACHER_OWN_CLASSES: 'teacher.own.classes',
  TEACHER_OWN_STUDENTS: 'teacher.own.students',
  TEACHER_OWN_ATTENDANCE: 'teacher.own.attendance',
  TEACHER_OWN_HOMEWORK: 'teacher.own.homework',
  TEACHER_OWN_CLASSWORK: 'teacher.own.classwork',
  TEACHER_OWN_TIMETABLE: 'teacher.own.timetable',
  TEACHER_OWN_NOTIFICATIONS: 'teacher.own.notifications',
  TEACHER_OWN_PROFILE: 'teacher.own.profile',

  // ── Leave Management ─────────────────────────────────────
  LEAVE_VIEW_OWN: 'leave.view.own',
  LEAVE_APPLY: 'leave.apply',
  LEAVE_MANAGE: 'leave.manage', // For principal/org admin

  // ── Academic Sessions ────────────────────────────────────
  ACADEMIC_SESSION_MANAGE: 'academic_session.manage',

  // ── Staff Management (Org Admin & Principal only) ────────
  STAFF_MANAGE_VIEW: 'staff_manage.view',
  STAFF_MANAGE_CREATE: 'staff_manage.create',
  STAFF_MANAGE_UPDATE: 'staff_manage.update',
  STAFF_MANAGE_DELETE: 'staff_manage.delete',

  // ── Student Attendance Settings (Principal & Org Admin only) ─
  STUDENT_ATTENDANCE_SETTINGS: 'student_attendance.settings',

  // ── Staff Attendance Settings (Principal & Org Admin only) ───
  STAFF_ATTENDANCE_SETTINGS: 'staff_attendance.settings',
});
